// extracted by mini-css-extract-plugin
export var icon = "EmployeeContact-module--icon--xYD-R";
export var root = "EmployeeContact-module--root--ER7Cm";